export function removeSpecificKeyLocalStorage(token: string) {
  const tokenLength = token.length;

  Object.keys(localStorage).forEach(key => {
    if (key.substring(0, tokenLength) === token) {
      localStorage.removeItem(key);
    }
  });
}
